var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "CustomerLevelsList",
      "extra-items": _vm.isShow ? [{
        text: _vm.form.name
      }] : _vm.isEditing ? [{
        text: _vm.form.name,
        to: 'CustomerLevelsView',
        params: {
          id: _vm.form.id
        }
      }, '編輯會員等級'] : ['新增會員等級']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isShow ? "查看會員等級" : !_vm.isEditing ? "新增會員等級" : "編輯會員等級") + " ")])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-8"
  }, [_c('div', {
    staticClass: "col-12 col-xl-9"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "等級名稱",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "type": "text",
      "state": _vm.v$.form.name.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.name.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label-for": "order"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 等級排序 "), _c('i', {
          staticClass: "fa fa-question-circle s-text-primary text-black-50",
          attrs: {
            "role": "button",
            "aria-hidden": "true",
            "id": "tooltip-for-order"
          }
        }), _c('b-tooltip', {
          attrs: {
            "target": "tooltip-for-order",
            "triggers": "hover",
            "placement": "right"
          }
        }, [_vm._v(" 數字越大，等級越高 ")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('b-form-input', {
          staticClass: "mb-2 mr-sm-2 mb-sm-0",
          attrs: {
            "id": "order",
            "type": "number",
            "state": _vm.v$.form.order.$error ? false : null,
            "disabled": _vm.isShow && !_vm.isEditing
          },
          model: {
            value: _vm.form.order,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "order", $$v);
            },
            expression: "form.order"
          }
        }), _c('b-form-invalid-feedback', {
          attrs: {
            "state": !_vm.v$.form.order.$error
          }
        }, [_vm._v("此欄位為必填")])];
      },
      proxy: true
    }])
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "等級代碼",
      "label-for": "code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "code",
      "type": "text",
      "value": _vm.form.code,
      "state": _vm.v$.form.code.$error ? false : null,
      "disabled": _vm.isShow,
      "placeholder": "僅支援英文字母、數字，以及底線（_）與減號（-）"
    },
    on: {
      "input": _vm.formCodeFilter
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.code.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "等級說明",
      "label-for": "description"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "description",
      "type": "text",
      "state": _vm.v$.form.description.$error ? false : null,
      "disabled": _vm.isShow,
      "row": "6"
    },
    model: {
      value: _vm.form.description,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.description.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 等級圖片 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：280px x 280px")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_vm.image.logo || _vm.form.logo_url ? _c('li', {
          staticClass: "s-image-list-item s-draggable"
        }, [_c('img', {
          staticClass: "s-cropped-image",
          attrs: {
            "src": _vm.image.logo || _vm.form.logo_url
          }
        }), !_vm.isShow ? _c('button', {
          staticClass: "btn btn-danger s-delete-btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteLogoImage();
            }
          }
        }, [_vm._v(" Ｘ ")]) : _vm._e()]) : _c('li', {
          staticClass: "s-image-list-item"
        }, [!_vm.isShow ? _c('ImageSelectorWithoutCrop', {
          on: {
            "input": function input(croppedImage) {
              return _vm.selectImage(croppedImage, 'logo');
            }
          },
          scopedSlots: _vm._u([{
            key: "trigger",
            fn: function fn(_ref) {
              var openFileSelector = _ref.openFileSelector;
              return [_c('button', {
                staticClass: "btn s-trigger-btn",
                on: {
                  "click": openFileSelector
                }
              }, [_vm._v(" ＋ 加入照片 ")])];
            }
          }], null, false, 832809640)
        }) : _vm._e()], 1)];
      },
      proxy: true
    }])
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 會員卡底圖 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 880px")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_vm.image.cardPicture || _vm.form.card_picture_url ? _c('li', {
          staticClass: "s-image-list-item s-draggable"
        }, [_c('img', {
          staticClass: "s-cropped-image",
          attrs: {
            "src": _vm.image.cardPicture || _vm.form.card_picture_url
          }
        }), !_vm.isShow ? _c('button', {
          staticClass: "btn btn-danger s-delete-btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteCardPictureImage();
            }
          }
        }, [_vm._v(" Ｘ ")]) : _vm._e()]) : _c('li', {
          staticClass: "s-image-list-item"
        }, [!_vm.isShow ? _c('ImageSelectorWithoutCrop', {
          attrs: {
            "aspect-ratio": 1400 / 880
          },
          on: {
            "input": function input(croppedImage) {
              return _vm.selectImage(croppedImage, 'cardPicture');
            }
          },
          scopedSlots: _vm._u([{
            key: "trigger",
            fn: function fn(_ref2) {
              var openFileSelector = _ref2.openFileSelector;
              return [_c('button', {
                staticClass: "btn s-trigger-btn",
                on: {
                  "click": openFileSelector
                }
              }, [_vm._v(" ＋ 加入照片 ")])];
            }
          }], null, false, 832809640)
        }) : _vm._e()], 1)];
      },
      proxy: true
    }])
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "會籍期限",
      "label-for": "order"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "form-inline col-12",
    model: {
      value: _vm.validity_permanent,
      callback: function callback($$v) {
        _vm.validity_permanent = $$v;
      },
      expression: "validity_permanent"
    }
  }, [_c('b-form-radio', {
    staticClass: "form-inline",
    attrs: {
      "value": "0",
      "disabled": _vm.isShow
    }
  }, [_vm._v("永久會籍")]), _c('b-form-radio', {
    staticClass: "form-inline",
    attrs: {
      "value": "1",
      "disabled": _vm.isShow
    }
  }, [_vm._v("設定有效期限")]), _c('b-input-group', {
    staticClass: "ml-1"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "disabled": _vm.isShow || _vm.isUnlimited
    },
    model: {
      value: _vm.form.renew_month,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "renew_month", $$v);
      },
      expression: "form.renew_month"
    }
  }), _c('b-input-group-append', [_c('b-input-group-text', [_vm._v("個月")])], 1)], 1)], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "是否啟用",
      "label-for": "is_enabled"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "is_enabled",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_enabled", $$v);
      },
      expression: "form.is_enabled"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "啟用期間"
    }
  }, [_c('div', {
    staticClass: "\n                d-flex\n                flex-column flex-xl-row\n                align-items-start align-items-xl-center\n              "
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "請選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isShow,
      "disabledDates": _vm.disabledDates,
      "clear-button": ""
    },
    model: {
      value: _vm.start_at,
      callback: function callback($$v) {
        _vm.start_at = $$v;
      },
      expression: "start_at"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "請選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isShow,
      "disabledDates": _vm.disabledDates,
      "clear-button": ""
    },
    model: {
      value: _vm.end_at,
      callback: function callback($$v) {
        _vm.end_at = $$v;
      },
      expression: "end_at"
    }
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.start_at.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "等級貼標"
    }
  }, [_c('TagsBox', {
    attrs: {
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.reached_tags,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reached_tags", $$v);
      },
      expression: "form.reached_tags"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "設定為預設等級",
      "label-for": "is_default"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "is_default",
      "disabled": _vm.isShow || _vm.isEnabledDefaultNull
    },
    model: {
      value: _vm.form.is_default,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_default", $$v);
      },
      expression: "form.is_default"
    }
  })], 1)], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回")]), !_vm.isShow ? _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditing ? "確認修改" : "確認新增") + " ")])], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }